import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo13 } from "../../../routes/Module13";
import Sidebar from "../Sidebar";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import GuiaDocente from "../../../components/GuiaDocente";
import Imagen3 from "../../../images/modulo13/limpiezario.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad1Actividad9.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo13.content[0];
  const infoAct = modulo13.content[0].activities[11];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titlePrev: `${modulo13.content[0].name}: ${modulo13.content[0].activities[10].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[10].path}`,
    titleNext: `${modulo13.content[0].name}: ${modulo13.content[0].activities[12].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[12].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul className="mb-4">
        <li>Observa la siguiente imagen.</li>
      </ul>
      <img src={Imagen3} alt="Electores" className="img-fluid mb-4" />

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul className="mb-4">
            <li>Responde las siguientes preguntas:</li>
          </ul>

          <p>¿Qué está pasando en la imagen?</p>
          <textarea rows={3} className="form-control mb-4" />

          <p>¿Dónde están?</p>
          <textarea rows={3} className="form-control mb-4" />

          <p>¿Qué personajes aparecen? ¿Qué hace cada uno de ellos?</p>
          <textarea rows={3} className="form-control mb-5" />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique que estas actividades tienen como objetivo que tomen
            conciencia de la importancia de tener un rol activo frente a los
            problemas que presenta nuestro entorno.
          </li>
          <li>
            Lea la primera indicación: Observa la siguiente imagen. Pida que en
            silencio observen todos los detalles que presenta la imagen. Pida
            que trabajen en parejas o con un familiar y lea la segunda indicación: Conversa con un
            compañero o compañera sobre lo siguiente: ¿Dónde están? ¿Qué está
            pasando en la imagen? ¿Qué personajes aparecen? ¿Qué hace cada uno
            de ellos?
          </li>
          <li>
            Retome algunas de las respuestas dadas a cada una de las preguntas.
            Por ejemplo:
            <ul>
              <li>
                <i>
                  “¿Dónde están? (Posible respuesta: Están en las laderas de un
                  río).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué está pasando en la imagen? Posible respuesta: En la
                  imagen se observa que el río está contaminado. Hay varias
                  personas que se han organizado para limpiar el río).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué personajes aparecen? ¿Qué hace cada uno de ellos?
                  (Posible respuesta: Se observa a diferentes personas
                  recogiendo los deshechos del río. También están presentes los
                  trabajadores de la municipalidad. La municipalidad ha brindado
                  un camión para recoger los deshechos. Vemos también a la
                  empresa Macana S.A.C que está colaborando con la limpieza del
                  río)”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Pregunte cuáles creen que son las consecuencias de no tomar ninguna
            acción frente a un problema como este. Cierre la actividad
            comentando la importancia de que diferentes personas (ciudadanos
            comunes, funcionarios de la Municipalidad y una empresa) actúen ante
            un problema de la comunidad. En este caso, se trata de la limpieza
            del río, un problema que afecta a todos.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
